import { render, staticRenderFns } from "./support_ticket_create.vue?vue&type=template&id=2a59050e&scoped=true&"
import script from "./support_ticket_create.vue?vue&type=script&lang=js&"
export * from "./support_ticket_create.vue?vue&type=script&lang=js&"
import style0 from "./support_ticket_create.vue?vue&type=style&index=0&id=2a59050e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a59050e",
  null
  
)

export default component.exports